import { render, staticRenderFns } from "./VendorSignup.vue?vue&type=template&id=52dc0fa2&scoped=true"
import script from "./VendorSignup.vue?vue&type=script&lang=js"
export * from "./VendorSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc0fa2",
  null
  
)

export default component.exports